import { render, staticRenderFns } from "./veBaseStudentEdit.vue?vue&type=template&id=3c65c1e8&scoped=true"
import script from "./veBaseStudentEdit.vue?vue&type=script&lang=js"
export * from "./veBaseStudentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c65c1e8",
  null
  
)

export default component.exports